<template>
  <el-upload
    class="singleimg-uploader"
    :action="uploadImg"
    :show-file-list="false"
    accept=".webp,.bmp,.pcx,.tif,.gif,.jpeg,.tag,.exif,.fpx,.svg,.png,.ico,.jpg"
    :before-upload="beforeAvatarUpload"
    :on-success="handleSuccess"
    :on-error="handleError">
    <img v-if="imageUrl!==null&&imageUrl!==''&&imageUrl!==undefined" :src="imageUrl" :style="size!==null&&size!==undefined?`width:${size[0]}px;height:${size[1]}px`:''" class="singleimg">
    <i v-else class="el-icon-plus singleimg-uploader-icon" :style="size!==null&&size!==undefined?`width:${size[0]}px;height:${size[1]}px;line-height:${size[1]}px;`:''"></i>
  </el-upload>
</template>

<script>
export default {
  name: 'SingleImgRestrict',
  props: {
    value: {
      type: Object
    },
    oldurl: {
      type: String
    },
    size: {
      type: Array
    },
    max: {
      type: Number,
      default: 0
    },
    restrict: {
      type: Number
    }
  },
  data() {
    return {
      uploadImg: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImgWx',
      imageUrl: '',
      limit: 0
    }
  },
  created() {
    this.imageUrl = this.oldurl
    this.limit = this.restrict
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < this.limit
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过限制' + this.limit)
      }
      return isLt2M
    },
    handleSuccess(res, file) {
      if (this.max !== null && this.max !== undefined && this.max > 0) {
        if (res.data.dWidth > this.max || res.data.dHeight > this.max) {
          this.$message.error('上传图片像素宽高不得超过' + this.max)
        } else {
          this.imageUrl = URL.createObjectURL(file.raw)
          const data = { imgid: res.data.dImgid, imgurl: this.imageUrl }
          this.$emit('input', data)
        }
      } else {
        this.imageUrl = URL.createObjectURL(file.raw)
        const data = { imgid: res.data.dImgid, imgurl: this.imageUrl }
        this.$emit('input', data)
      }
    },
    handleError() {
      this.$message({
        type: 'error',
        message: '图片上传失败，请稍后重试'
      })
    }
  }
}
</script>

